import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {MyScoresWidgetPlaceholder} from "./placeholders/my-scores-widget.placeholder";

const MyScoresWidgetAsyncComponent = AsyncComponent(async () => import('./my-scores-widget' /* webpackChunkName: "my-scores-widget" */ ));

export const MyScoresWidgetAsync = (props) => {
  return <React.Suspense fallback={<MyScoresWidgetPlaceholder {...props} shouldRenderHeader/>}>
    <MyScoresWidgetAsyncComponent {...props}/>
  </React.Suspense>
}
